module.exports = __webpack_public_path__ + "img/arrow-left.765c7fcf.svg";